import React, { ReactElement } from 'react'
import { Flex, Icon, ResetButton, Text } from '@mindfulchefuk/design-system'
import { CurrentRefinementsProvided } from 'react-instantsearch-core'
import { connectCurrentRefinements } from 'react-instantsearch-dom'

export const UnconnectedModalToggle = ({
  items,
  onClick,
}: Partial<CurrentRefinementsProvided> & {
  onClick: () => void
}): ReactElement => (
  <ResetButton
    fullWidth
    type="button"
    onClick={onClick}
    data-testid="open-filters-modal"
  >
    <Flex align="center" justify="space-between" width="100%">
      <Text variant="heading-sm" data-testid="modal-toggle-text">
        {items.length ? 'Filters applied' : 'Filters'}
      </Text>

      <Icon type="filter" size={32} ml={8} />
    </Flex>
  </ResetButton>
)

export const ModalToggle = connectCurrentRefinements(UnconnectedModalToggle)
